// extracted by mini-css-extract-plugin
export default {"filterBox":"styles_filterBox__RsC3x","icon":"styles_icon__aG8qt","icon-24":"styles_icon-24__8ilbU"};